import { variables } from '../common/variables';

import { cl } from '../common/functions';

let ajax = (success, error) => {
  if (window.fetch) {
    Object.keys(variables.params).forEach(key =>
      variables.url.searchParams.append(key, variables.params[key])
    );
    fetch(variables.url, {
      headers: { "Content-Type": "application/json; charset=utf-8" }
    })
      .then(response => response.json())
      .then(success)
      .catch(error);
  } else {
    if (window.jQuery) {
      jQuery.ajax({
        dataType: "json",
        url: variables.url,
        data: variables.params,
        success: success,
        error: error
      });
    }
  }
};

export { ajax };
